import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
  title: string;
  subtitle?: string;
}
export function Layout({
  children,
  currentPage,
  onNavigate,
  title,
  subtitle
}: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-138">
      <div className="hidden lg:block flex-shrink-0 w-64" data-id="element-139">
        <Sidebar currentPage={currentPage} onNavigate={onNavigate} isOpen={true} onToggle={() => setSidebarOpen(false)} data-id="element-140" />
      </div>
      <div className="lg:hidden" data-id="element-141">
        <Sidebar currentPage={currentPage} onNavigate={onNavigate} isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-142" />
      </div>
      <div className="flex-1 flex flex-col min-h-screen min-w-0" data-id="element-143">
        <Header title={title} subtitle={subtitle} onNavigate={onNavigate} data-id="element-144" />
        <main className="flex-1 p-4 lg:p-8 overflow-auto" data-id="element-145">{children}</main>
      </div>
    </div>;
}